/*
|--------------------------------------------------------------------------
| App View
|--------------------------------------------------------------------------
| 
*/

define('views/AppView',[
    'backbone',
    'lodash',
    'text!templates/app.html',
    'app',
    'routers/routes',
    'views/HeaderView',
    'modernizr'
], function (Backbone, _, appTmpl, App, routes, HeaderView, Modernizr) {

    "use strict";

    return Backbone.View.extend({

        el: $('#app'),

        initialize: function () {
            this.$el.html(this.template(App));
            this.$content = this.$el.find('#content');

            // header
            this.header = new HeaderView();
            this.$el.prepend(this.header.el);

            this.description = "ESTATE FOUR is an international investment and development group well known for creating innovative workspaces dedicated to the global fashion, art and design industries. Led by Alessandro Cajrati Crivelli, over the course of the past 18 years EST4TE FOUR built its reputation developing and investing in creative hubs in Milan, London, and New York that successfully combined modern design with the existing architectural fabric of their distinctive locales. Through the transformation of historical buildings and former industrial areas into communities each project reinvigorates its urban zone."

            window.app = App;
        },

        template: _.template(appTmpl),

        events: {
            "click a:not([target])": "clickLink",
            "mouseenter a:not([target])": "preload"
        },

        currentView: null,

        transDefer: $.Deferred(),

        clickLink: function (event) {
            var href = event.currentTarget.href;
            if (App.router && href) {
                App.router.goTo(href, true);
                event.preventDefault();
            }
        },

        /*
            TODO: facebook, twitter meta tags
         */
        changeMeta: function (meta) {
            var title = meta.title ? meta.title + ' | ' + App.siteTitle : App.siteTitle,
                description = meta.description ? meta.description : '';

            $('title').html(title);
            $('meta[name="description"]').attr('content', this.description);
            $('meta[property="og:description"]').attr('content', this.description);
            $('meta[name="twitter:description"]').attr('content', this.description);
        },

        setHeader: function (view) {
            // use url fragment to determined which method to be called
            var fragment = Backbone.history.fragment;
            fragment = fragment.match(/^(.*?)(\/|$)/i)[1] || '';

            this.header.highlight(fragment);

            if (view.meta) {
                this.changeMeta(view.meta);
            } else {
                this.changeMeta(App.meta[fragment] ? App.meta[fragment] : {});
            }
        },

        render: function (View, transition, args) {
            $('body').removeClass();
            var current     = this.currentView,
                target      = new View(args);
            
            this.setHeader(target);

            // force to resolve any unfinished transition
            this.transDefer.resolve();

            // force to show defer images after 3 secs
            setTimeout(_.bind(this.forceShowImgs, this, target.el), 3000);

            // render target view
            this.$content.append(target.el);
            if (!transition || !target.transition) {
                target.render.apply(target, args);
                if (current) {
                    current.remove();
                }
            } else {
                this.transition(current, target);
            }

            this.currentView = target;
        },

        transition: function (current, target) {
            this.noScroll();
            target.$el.css('position', 'fixed');
            target.$el.addClass('transition');
            var defer = target.transition();
            if (typeof defer === 'number') {
                defer = this.timeoutDefer(defer);
            }

            this.transDefer = $.when(defer).done(_.bind(function () {
                target.$el.css('position', '');
                this.enableScroll();
                if (current) {
                    current.remove();
                }
            }, this));
        },

        timeoutDefer: function (duration) {
            var defer = $.Deferred();
            setTimeout(function () {
                defer.resolve();
            }, duration);
            return defer;
        },

        noScroll: function () {
            $('body').addClass('noscroll');
            if (Modernizr.touch) {
                $(document).on('touchmove.noscroll', function (event) {
                    event.preventDefault();
                });
            }
        },

        enableScroll: function () {
            $('body').removeClass('noscroll');
            if (Modernizr.touch) {
                $(document).unbind('touchmove.noscroll');
            }
        },

        forceShowImgs: function (el) {
            $(el)
                .find('.defer-img img:not(.loaded)').addClass('loaded')
                .find('.defer-bk-img:not([style])').each(function () {
                    var img = $(this).find(img),
                        src = img.attr(src);
                    $(this).css('backgroundImage', src);
                    img.remove();
                });
        },

        preloaded: [],

        preload: function (event) {
            var href = event.currentTarget.href;

            if (this.preloaded.indexOf(href) !== -1) {
                return;
            }

            var match = App.router.match(href);
            if (match.View.extend) {
                var view = new match.View(match.args);

                if (view.preload) {
                    view.preload();
                } else if (view.template) {
                    view.template(App);
                }

                this.preloaded.push(href);
            }
        }

    });
});
